import { Cancel } from 'iconoir-react'
import moment from 'moment'
import React from 'react'

const ViewNotificationModal = ({onCancel, notification}) => {
  return (
    <div className="fixed z-20 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity">
          <div className="absolute inset-0 bg-gray-900 bg-opacity-75"></div>
        </div>
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
        <div className="inline-block p-5 align-bottom w-2/6 rounded-lg bg-white text-left overflow-hidden shadow-xl transform transition-all sm:my-12 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
          <label className='flex justify-between mb-5'>
            <h1 className='text-lg wayrideColor font-bold'>View Notification</h1>
            <Cancel onClick={onCancel} className='cursor-pointer bg-gray-300 rounded-full text-gray-900 h-7 w-7 p-1' />
          </label>
          <span className="text-gray-500 text-sm">Sent On:</span>
          <p className='text-sm'>{moment(notification.createdAt).format('LLLL')}</p>
          <br />
          <span className="text-gray-500 text-sm">By:</span>
          <p className='text-sm'>{notification.admin.lastname} {notification.admin.firstname}</p>
          <br />
          <label className="block mb-5 col-span-3 text-sm">
            <span className="text-gray-500 dark:text-gray-400">Notification message</span>
            <textarea
              rows="5"
              readOnly
              className="block w-full border px-3 text-gray-600 py-2 rounded mt-1 text-sm border-gray-400 dark:bg-gray-700 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
              placeholder="Notification message"
              name="notification_message"
              value={notification.message}
            />
          </label>
        </div>
      </div>
    </div>
  )
}

export default ViewNotificationModal